import React from 'react';
import ReactDOM from 'react-dom';

import FontPickerStateController from 'ub/fonts/font-picker/state-controller';
import FontPickerModal from './font-picker-modal';
import { createFontPickerWrapper } from './utils';

const buildFontPickerModal = props => {
  return (
    <FontPickerModal
      modalActionsSubject={FontPickerStateController.modalActionsSubject}
      {...props}
    />
  );
};

const render = props => {
  const fontPickerModal = buildFontPickerModal(props);
  const fontPickerWrapper = createFontPickerWrapper();

  ReactDOM.render(fontPickerModal, fontPickerWrapper);
};

export default { render };



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-builder.jsx